import styled from 'styled-components'

export const Container = styled.div`
	display: flex;
	align-items: flex-end;
	justify-content: space-between;
	margin-top: 64px;
	overflow: hidden;

	@media only screen and (max-width: 1010px) {
		flex-direction: column-reverse;
		align-items: flex-start;
	}
`
